import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Page title
document.title = 'Бухгалтер';
// OG / Social preview meta tags
const setMeta = (property: string, content: string, isName = false) => {
  const attr = isName ? 'name' : 'property';
  let el = document.querySelector(`meta[${attr}="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};
// Open Graph
setMeta('og:type', 'website');
setMeta('og:title', 'Бухгалтерські послуги для бізнесу — демо-сайт від Jetly');
setMeta('og:description', 'Це демо-сайт. Ми можемо зробити такий самий для вашого бізнесу — від 9 000 грн. Залиште заявку на jetly.agency/ua');
setMeta('og:url', 'https://jetly.agency/ua');
setMeta('og:site_name', 'Jetly Agency');
// Twitter / X
setMeta('twitter:card', 'summary_large_image', true);
setMeta('twitter:title', 'Бухгалтерські послуги — демо-сайт від Jetly', true);
setMeta('twitter:description', 'Це демо-сайт. Ми можемо зробити такий самий для вашого бізнесу — від 9 000 грн. Залиште заявку на jetly.agency/ua', true);
// Description for SEO
setMeta('description', 'Це демо-сайт бухгалтерських послуг. Jetly Agency може адаптувати цей дизайн або створити сайт з нуля для вашого бізнесу від 9 000 грн.', true);
render(<App data-id="element-371" />, document.getElementById('root'));